import { apiClient } from "../config";

async function uploadFileByUrl(
  module: string = "observation",
  fileStatus: "public" | "private" = "public",
  url: string
) {
  const data = {
    module,
    status: fileStatus,
    url,
  };

  const res = await apiClient.post("/admin/file/by-url", data);
  return res.data;
}

export default uploadFileByUrl;
